import React, { useEffect } from 'react';
import Resizer from "react-image-file-resizer";
import { MediaUpload } from '../../../../Constant/api';

export default function FileUploadImage(props) {
  const {
    ImageGroup,
    setImageGroup,
    ThisImage,
    index, type
  } = props;
  const fileRefSingle = React.createRef();
  const [Loading, setLoading] = React.useState(false)
  const [URL, setURL] = React.useState("")
  const [ImageSelect, setImageSelect] = React.useState("")

  const MediaUploadSingleCall = (file, i) => {
    MediaUpload(file)
      .then(res => res.json())
      .then(data => {
        setURL(data.source_url)
        var pdf = ImageGroup;
        pdf = {
          ...pdf,
          [`${index}`]: `${data.source_url}`
        }
        setImageGroup(pdf)
        setTimeout(() => {
          setLoading(false)
        }, 1000);
      })
      .catch(err => { console.log("error", err.message); })
      .finally(() => { })
  }

  return (
    <div>
      {Loading &&
        <div className="spinner-border"></div>
      }
      <div className="">
        <div className="row">
          {ThisImage != "" ?
            <div className="">
              <div>
                <div className=" ">
                  <button type="button" onClick={() => {
                    // fileRefSingle.current.click() 
                    setImageSelect(ThisImage)
                  }}
                    className="bg-transparent border-0 p-1 "
                  >
                    <img src={`${ThisImage}`} className={" border border-dark"}
                      height="100px"
                    />
                  </button>
                </div>
              </div>
              <button onClick={() => {
                var pdf = ImageGroup;
                pdf = {
                  ...pdf,
                  [`${index}`]: ""
                }
                setImageGroup(pdf)
              }}
                className="bg-transparent border-0 p-1 "
              >
                <u>Clear</u></button>
            </div>
            :
            <div className="col-3">
              <button type="button"
                onClick={() => {
                  fileRefSingle.current.click()
                }}
                className="bg-transparent border-0 "
              >
                <div style={{ padding: "3px 7px", border: "0.5px solid #999", borderRadius: "3px" }}>
                  {/* <i className="fa fa-file-pdf-o font-size-18"></i> */}
                  <div>Add</div>
                </div>
              </button>
            </div>
          }
        </div>
      </div>
      <div style={{ display: 'none' }}>
        {/* {type == "audio" ?
          <input type="file" accept="audio/*" name="image" id="file" ref={fileRefSingle}
            onChange={(event) => {
              if (event.target.files.length !== 0) {
                setLoading(true)
                MediaUploadSingleCall(event.target.files[0])
              }
            }}
          />
          : */}
        <input type="file" accept="file/*" name="image" id="file" ref={fileRefSingle}
          onChange={(event) => {
            if (event.target.files.length !== 0) {
              setLoading(true)
              MediaUploadSingleCall(event.target.files[0])
            }
          }}
        />
        {/* } */}
      </div>
      {ImageSelect !== "" &&
        <div className="modal center image-zoom-modal"
          onClick={() => {
            setImageSelect("")
          }}
        >
          <img style={{ width: "80%",height:"80%",objectFit:"contain" }}
            src={ImageSelect}
          />

        </div>
      }
    </div>
  )
}